import { Typography } from '@material-ui/core'

import { getTranslate } from '../../../../localization'
import useStyles from './styles'

/**
 * The card's title and the one line explaining what it does.
 *
 * Static presentation, extracted so the component below reads as composition rather than
 * markup. The explanation matters more than it looks: without it a booker sees a code
 * field and reasonably assumes entering a code is the ONLY way to get a discount, when the
 * best available offer is already being applied for them.
 */
const CardHeading = () => {
  const classes = useStyles()

  return (
    <>
      <Typography variant="subtitle1" className={classes.title}>
        {getTranslate('Promotion code')}
      </Typography>
      <Typography variant="body2" className={classes.description}>
        {getTranslate(
          'The best available promotion is checked automatically. You can also enter an optional code.'
        )}
      </Typography>
    </>
  )
}

export default CardHeading
